var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never", "body-style": { padding: 0 } } },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small", "label-width": "85px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品关键字：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入关键字",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.tableFrom.merKeywords,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "merKeywords", $$v)
                          },
                          expression: "tableFrom.merKeywords",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号码：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入订单号",
                          size: "small",
                          clearable: "",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.seachList($event)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "orderNo", $$v)
                          },
                          expression: "tableFrom.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间：" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                          size: "small",
                        },
                        on: { change: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "物流单号：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入物流单号",
                          size: "small",
                          clearable: "",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.seachList($event)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.deliveryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "deliveryId", $$v)
                          },
                          expression: "tableFrom.deliveryId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付方式：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            clearable: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.tableFrom.payType,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "payType", $$v)
                            },
                            expression: "tableFrom.payType",
                          },
                        },
                        _vm._l(_vm.payTypes, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-search",
                            size: "small",
                          },
                          on: { click: _vm.seachList },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", icon: "el-icon-refresh" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.summaryLoading,
              expression: "summaryLoading",
            },
          ],
          staticClass: "summary-card mt14",
          attrs: { shadow: "never" },
        },
        [
          _c("div", { staticClass: "summary-grid" }, [
            _c("div", { staticClass: "summary-row total-row" }, [
              _vm.orderStatisticsData.length > 0
                ? _c("div", { staticClass: "summary-item" }, [
                    _c("span", { staticClass: "summary-label" }, [
                      _vm._v(
                        _vm._s(_vm.orderStatisticsData[0].payTypeStr) + ":"
                      ),
                    ]),
                    _c(
                      "span",
                      { staticClass: "summary-value amount-success" },
                      [_vm._v(_vm._s(_vm.orderStatisticsData[0].totalAmount))]
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm.orderStatisticsData.length > 1
              ? _c(
                  "div",
                  { staticClass: "summary-row user-row" },
                  _vm._l(_vm.orderStatisticsData, function (item) {
                    return item.payType !== "all"
                      ? _c(
                          "div",
                          { key: item.payType, staticClass: "summary-item" },
                          [
                            _c("span", { staticClass: "summary-label" }, [
                              _vm._v(_vm._s(item.payTypeStr) + ":"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "summary-value amount-primary" },
                              [_vm._v(_vm._s(item.totalAmount))]
                            ),
                          ]
                        )
                      : _vm._e()
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.seachList },
                  model: {
                    value: _vm.tableFrom.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.tableFrom, "status", $$v)
                    },
                    expression: "tableFrom.status",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: {
                      name: "all",
                      label: "全部(" + (_vm.orderChartType.all || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "unPaid",
                      label: "未支付(" + (_vm.orderChartType.unPaid || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "notShipped",
                      label:
                        "未发货(" + (_vm.orderChartType.notShipped || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "spike",
                      label: "待收货(" + (_vm.orderChartType.spike || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "bargain",
                      label:
                        "待评价(" + (_vm.orderChartType.bargain || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "complete",
                      label:
                        "已完成(" + (_vm.orderChartType.complete || 0) + ")",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      name: "refunding",
                      label:
                        "退款中(" + (_vm.orderChartType.refunding || 0) + ")",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.exportLoading,
                      expression: "exportLoading",
                    },
                  ],
                  on: { click: _vm.exports },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "订单号", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          staticStyle: { display: "block" },
                          domProps: { textContent: _vm._s(scope.row.orderId) },
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: scope.row.isDel,
                                expression: "scope.row.isDel",
                              },
                            ],
                            staticStyle: { color: "#ed4014", display: "block" },
                          },
                          [_vm._v("用户已删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "realName", label: "收货人", "min-width": "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品信息", "min-width": "320" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.productList && scope.row.productList.length
                          ? _c(
                              "div",
                              _vm._l(scope.row.productList, function (val, i) {
                                return _c(
                                  "div",
                                  {
                                    key: i,
                                    staticClass: "tabBox acea-row row-middle",
                                    staticStyle: { "flex-wrap": "inherit" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "demo-image__preview mr10",
                                      },
                                      [
                                        _c("el-image", {
                                          attrs: {
                                            src: val.info.image,
                                            "preview-src-list": [
                                              val.info.image,
                                            ],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "text_overflow" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "tabBox_tit mr10" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                val.info.productName + " | "
                                              ) + _vm._s(val.info.sku || "-")
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "tabBox_pice" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                "￥" +
                                                  val.info.price +
                                                  " x " +
                                                  val.info.payNum
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "payPrice",
                  label: "实际支付",
                  "min-width": "80",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "支付方式", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.payTypeStr))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "订单状态", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(_vm.statusText(scope.row)))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "180", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.onOrderDetails(scope.row.orderId)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        scope.row.statusStr.key === "notShipped" &&
                        scope.row.refundStatus === 0
                          ? [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.sendOrder(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("发货")]
                              ),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                            ]
                          : _vm._e(),
                        scope.row.statusStr.key === "spike" &&
                        scope.row.type === 0 &&
                        !scope.row.shipmentTaskId
                          ? [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUpdateNumber(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("改单号")]
                              ),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                            ]
                          : _vm._e(),
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v("更多"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.onOrderLog(scope.row.orderId)
                                      },
                                    },
                                  },
                                  [_vm._v("订单记录")]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.onOrderMark(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("订单备注")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 40, 60],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.detailVisible,
            direction: _vm.direction,
            size: "800px",
            "before-close": _vm.handleDetailClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _vm.orderDatalist
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.detailLoading,
                      expression: "detailLoading",
                    },
                  ],
                  staticClass: "order-detail-drawer",
                },
                [
                  _c("div", { staticClass: "detailHead" }, [
                    _c("div", { staticClass: "full" }, [
                      _c("div", { staticClass: "order_icon" }, [
                        _c("span", {
                          staticClass: "iconfont icondingdanguanli",
                        }),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.orderDatalist.orderTypeText || "-")
                          ),
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "mr20" }, [
                            _vm._v(
                              "订单号：" + _vm._s(_vm.orderDatalist.orderId)
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("ul", { staticClass: "list" }, [
                      _vm.orderDatalist.statusStr
                        ? _c("li", { staticClass: "item" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("订单状态"),
                            ]),
                            _c("div", { staticClass: "color-warning" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.orderDatalist.statusStr.value)
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("实际支付"),
                        ]),
                        _c("div", [
                          _vm._v(
                            "¥ " + _vm._s(_vm.orderDatalist.payPrice || "0.0")
                          ),
                        ]),
                      ]),
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("支付方式"),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm._f("payTypeFilter")(_vm.orderDatalist.payType)
                            )
                          ),
                        ]),
                      ]),
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("创建时间"),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.orderDatalist.createTime || "-")),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "detailSection padBox",
                      staticStyle: { border: "none" },
                    },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("用户信息")]),
                      _c("ul", { staticClass: "list" }, [
                        _c("li", { staticClass: "item" }, [
                          _c("div", { staticClass: "lang" }, [
                            _vm._v("用户名称："),
                          ]),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(_vm.orderDatalist.nikeName) +
                                " | " +
                                _vm._s(_vm.orderDatalist.uid)
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "item" }, [
                          _c("div", { staticClass: "lang" }, [
                            _vm._v("用户电话："),
                          ]),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.orderDatalist.phone)),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _vm.orderDatalist.shippingType < 2
                    ? _c("div", { staticClass: "detailSection padBox" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("收货信息"),
                        ]),
                        _c("ul", { staticClass: "list" }, [
                          _c("li", { staticClass: "item" }, [
                            _c("div", { staticClass: "lang" }, [
                              _vm._v("收货人："),
                            ]),
                            _c("div", { staticClass: "value" }, [
                              _vm._v(_vm._s(_vm.orderDatalist.realName)),
                            ]),
                          ]),
                          _c("li", { staticClass: "item" }, [
                            _c("div", { staticClass: "lang" }, [
                              _vm._v("收货电话："),
                            ]),
                            _c("div", { staticClass: "value" }, [
                              _vm._v(_vm._s(_vm.orderDatalist.userPhone)),
                            ]),
                          ]),
                          _c("li", { staticClass: "item" }, [
                            _c("div", { staticClass: "lang" }, [
                              _vm._v("收货地址："),
                            ]),
                            _c("div", { staticClass: "value" }, [
                              _vm._v(_vm._s(_vm.orderDatalist.userAddress)),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "detailSection padBox" },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("商品信息")]),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.orderDatalist.orderInfo || [],
                            size: "small",
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "商品图", width: "80" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "50px",
                                          height: "50px",
                                        },
                                        attrs: { src: scope.row.info.image },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              717263077
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "info.productName",
                              label: "名称",
                              "min-width": "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "info.sku",
                              label: "规格",
                              "min-width": "80",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "info.price",
                              label: "单价",
                              width: "80",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "info.payNum",
                              label: "数量",
                              width: "60",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "操作记录",
            visible: _vm.logDialogVisible,
            width: "700px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.logDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.logLoading,
                  expression: "logLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { border: "", data: _vm.logData.list },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "oid", label: "ID", width: "80" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "changeMessage",
                  label: "操作记录",
                  "min-width": "280",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "操作时间",
                  "min-width": "160",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.logFrom.limit,
                  "current-page": _vm.logFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.logData.total,
                },
                on: {
                  "size-change": _vm.handleLogSizeChange,
                  "current-change": _vm.handleLogPageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("order-send", {
        ref: "send",
        attrs: {
          orderId: _vm.orderId,
          expressListNormal: _vm.expressListNormal,
          expressListElec: _vm.expressListElec,
          orderDetail: _vm.orderDetail,
        },
        on: { submitFail: _vm.getList },
      }),
      _c("order-video-send", {
        ref: "videoSend",
        attrs: { orderId: _vm.orderId },
        on: { submitFail: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }